<template>
<div id="main" class="column is-9">
	<ProfileHeader :psychic="psychic" />
	<section class="latest-readings" v-if="!eligibleVisible">
		<Spinner size="large" v-if="!idle"></Spinner>
		<div class="columns" v-if="idle">
			<div class="column">
				<div class="card">
					<header class="card-header">
					<p class="card-header-title">
						Compose Agent Email
					</p>
					</header>
					<div class="card-table">
						<div class="content">
							<form>
								<div class="field is-horizontal">
									<div class="field-label is-normal">
										<label class="label">To:</label>
									</div>
									<div class="field-body">
										<div class="field">
										<a class="button is-small is-primary" @click="eligibleVisible = true">Select Recipients</a>&nbsp; ({{gift.customers.length}} Selected)
										<p class="help is-danger" v-if="errors.customers">{{ errors.customers }}</p>
										</div>
									</div>
								</div>
								<div class="field is-horizontal">
									<div class="field-label is-normal">
										<label class="label">Subject:</label>
									</div>
									<div class="field-body">
										<div class="field">
											<p class="control is-expanded has-icons-left">
												<input class="input is-small" type="text" placeholder="Name" v-model="gift.subject" :class="{'is-danger': errors.subject }">
												<span class="icon is-small is-left">
												<i class="far fa-newspaper-o"></i>
												</span>
												<p class="help is-danger" v-if="errors.subject">{{ errors.subject }}</p>
										</div>
									</div>
								</div>
								<div class="field is-horizontal">
									<div class="field-label is-normal">
										<label class="label">Attach:</label>
									</div>
									<div class="field-body">
										<div class="field is-narrow">
											<div class="control has-icons-left">
												<div class="select is-small is-fullwidth">
													<select v-model="gift.minutes">
														<option v-for="min in minute_options" :key="min" :value="min"> {{min}} Minutes</option>
													</select>
												</div>
												<span class="icon is-small is-left">
												<i class="fa fa-gift"></i>
												</span>
											</div>
										</div>
									</div>
								</div>
								<div class="field is-horizontal">
									<div class="field-label is-normal">
										<label class="label">Message:</label>
									</div>
									<div class="field-body">
										<div class="field">
											<div class="control">
												<textarea class="textarea" :class="{'is-danger': errors.body }" placeholder="" v-model="gift.body"></textarea>
												<p class="help is-danger" v-if="errors.body">{{ errors.body }}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="field is-horizontal">
									<div class="field-label">
										<!-- Left empty for spacing -->
									</div>
									<div class="field-body">
										<div class="field is-grouped">
											<div class="control">
												<button class="button is-small is-primary" @click.prevent="submit">
												Send</button>
											</div>
											<div class="control">
												<button class="button is-small" @click.prevent="resetForm">
												Reset</button>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			</div>
		</section>
		<section class="customers" v-if="eligibleVisible" @mousedown="mouseDown = true" @mouseup="mouseDown = false">
			<Spinner size="large" v-if="!idle"></Spinner>
			<div class="columns" v-if="idle">
				<div class="column">
					<div class="card">
						<header class="card-header">
						<p class="card-header-title">
							Choose Customers &nbsp;&nbsp;<button class="button is-small is-primary is" @click="eligibleVisible = false">Select</button>
						</p>
						<p class="card-header-title">
							<PageSize v-model="pageSize" @input="$refs.paginator.goToPage(0)" />
						</p>
						<a @click="filterShown = true" class="button is-small is-primary filter right"><i class="fa fa-filter"></i></a>
						</header>
						<div class="card-table">
							<div class="content">
								<div class="table-container">
									<table id="allPsychics" class="table is-fullwidth is-striped">
									<thead>
									<tr>
										<th>
										All
											<div class="field">
												<div class="control">
													<input type="checkbox" @change="selectAllCustomers">
												</div>
											</div>
										</th>
										<th>
											<a @click="sortEligible('user_name')">Member</a>
										</th>
										<th class="is-hidden-mobile">
											<a @click="sortEligible('last')">Last Reading</a>
										</th>
										<th class="is-hidden-mobile">
											<a @click="sortEligible('calls')">Readings</a>
										</th>
										<th class="is-hidden-mobile">
											<a @click="sortEligible('minutes')">Call Length</a>
										</th>
										<th>
											<a @click="sortEligible('redeemable_minutes')"><span class="is-hidden-mobile">Unused</span></a>
										</th>
										<th>
											<a @click="sortEligible('alc')">ALC</a>
										</th>
										<th>
											<a @click="sortEligible('rev_per_call')">RPC</a>
										</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="customer in paginatedData" :key="customer.user_id" @mouseover="dragSelect(customer.user_id)">
										<td class="check-control">
											<div class="field">
												<div class="control">
													<label class="checkbox">
														<input type="checkbox" :value="customer.user_id" v-model="gift.customers">
													</label>
												</div>
											</div>
										</td>
										<td class=""><a @click="showCustomerDetail(customer)">{{ customer.user_name }}</a></td>
										<td class="is-hidden-mobile">{{formatDate(customer.last)}}</td>
										<td class="is-hidden-mobile">{{customer.calls}}</td>
										<td class="is-hidden-mobile">{{ customer.minutes }}</td>
										<td class="">{{ customer.redeemable_minutes }}</td>
										<td class="">{{ customer.alc}}</td>
										<td class="">{{ customer.rev_per_call }}</td>
									</tr>
									</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Paginator ref="paginator" :itemCount="this.eligible.length" :pageSize="this.pageSize" v-model="pageNumber" />
			</section>
		<Modal v-if="customerDetailShown" @close="customerDetailShown = false">
			<span slot="title">READING DETAILS FOR {{ selectedCustomer.user_name }}</span>
			<div class="columns" slot="body">
				<div class="column">
					<div class="card">
						<div class="card-table">
							<div class="content">
								<table class="table is-fullwidth is-striped">
									<thead>
										<tr>
											<th>
												<a @click="sortCustomerDetail('date')">Date/Time</a>
											</th>
											<th>
												<a @click="sortCustomerDetail('minutes')">Minutes</a>
											</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(detail, idx) in sortedCustomerDetail" :key="idx">
											<td>
												{{ formatDate(detail.date) }}
											</td>
											<td>
												{{ detail.minutes }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
		<Modal v-if="filterShown" @close="filterShown = false">
			<span slot="title">FILTER CUSTOMERS</span>
			<form slot="body">
			<label class="label">Filter RPC (&gt;=):</label>
			<div class="field">
				<p class="control">
					<input class="input is-small" type="text" placeholder="" v-model="filterRPC">
				</p>
			</div>
			<label class="label">Filter ALC (&gt;=):</label>
			<div class="field">
				<p class="control">
					<input class="input is-small" type="text" placeholder="" v-model="filterALC">
				</p>
			</div>
			<label class="label">Filter UFM (=):</label>
			<div class="field">
				<p class="control">
					<input class="input is-small" type="text" placeholder="" v-model="filterUFM">
				</p>
			</div>
		</form>
			<div slot="footer" class="field is-grouped">
				<div class="control">
					<a class="button is-small is-primary" @click="filterShown = false"><i class="fa fa-check"></i></a>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	import moment from "moment-timezone"
	import ProfileHeader from "./ProfileHeader.vue"
	import Paginator from "../Paginator.vue"
	import PageSize from "../PageSize.vue"
	import Modal from "../Modal.vue"
	import Spinner from 'vue-simple-spinner'

	export default {
		components: {
			ProfileHeader,
			Paginator,
			Modal,
			PageSize,
			Spinner,
		},
		data() {
			return {
				mouseDown: false,
				minute_options: [3,4,5,6,7],
				eligibleVisible: false,
				errors: {
					customers: null,
					body: null,
					subject: null
				},
				psychic: {},
				eligible: [],
				gift: {
					body: "",
					subject: "",
					minutes: 3,
					customers: []
				},
				pageNumber: 0,
				pageSize: 1000000,
				sortCol: "rev_per_call",
				sortDir: -1,
				selectedCustomer: {},
				customerDetail: [],
				customerDetailShown: false,
				customerDetailSortDir: -1,
				customerDetailSortCol: "date",
				filterShown: false,
				filterRPC: "",
				filterALC: "",
				filterUFM: "",
				idle: false,
			}
		},
		methods: {
			dragSelect(id) {
				if (this.mouseDown) {
					for(let i = 0; i < this.gift.customers.length; i++) {
						if (this.gift.customers[i] === id) {
							return
						}
					}

					this.gift.customers.push(id)
				}
			},
			cleanErrors() {
				this.errors = {
					customers: null,
					body: null,
					subject: null
				}
			},
			async showCustomerDetail(customer) {
				this.customerDetail = await this.$root.$data.getters.getCustomerDetail(this.$root.$data.state, this.$route.params["id"], customer.user_id)
				this.selectedCustomer = customer
				this.customerDetailShown = true
				this.customerDetailSortCol = "date"
				this.customerDetailSortDir = -1
			},
			sortCustomerDetail(col) {
				if (col === this.customerDetailSortCol) {
					this.customerDetailSortDir = this.customerDetailSortDir === -1 ? 1 : -1
				} else {
					this.customerDetailSortCol = col
					this.customerDetailSortDir = -1
				}
			},
			checkForm() {
				this.cleanErrors()
				if (!this.gift.subject || this.gift.subject.trim().length == 0) {
					this.errors.subject = "Subject is required"
				} else if (this.gift.subject.trim().length > 100) {
					this.errors.subject = "Subject cannot exceed 100 characters"
				} 

				if (!this.gift.body || this.gift.body.trim().length == 0) {
					this.errors.body = "A message body is required"
				} else if (this.gift.body.trim().length > 4000) {
					this.errors.body = "Message body cannot exceed 4000 characters"
				}

				if (this.gift.customers.length < 1) {
					this.errors.customers = "You must select at least one recipient"
				}


				for (const key in this.errors) {
					if (this.errors[key] !== null) { return false }
				}

				return true
			},
			async submit() {
				if (this.checkForm()) {
					this.idle = false
					await this.$root.$data.setters.sendGifts(this.$root.$data.state, this.$route.params["id"], this.gift)
					this.$notify({
						group: 'global',
						type: 'success',
						title: 'Gifts Sent',
						text: 'Your gifts are being processed now.',
					})
					this.eligible = await this.$root.$data.getters.getEligibleGifts(this.$root.$data.state, this.$route.params["id"])
					this.resetForm()
					this.idle = true
				}
			},
			resetForm() {
				this.gift = {
					body: "",
					subject: "",
					minutes: 3,
					customers: []
				}
			},
			selectAllCustomers(e) {
				const data = this.sortedEligible
				for(let i = 0; i < data.length; i++) {
					if (e.target.checked && !this.gift.customers.includes(data[i].user_id)) {
						this.gift.customers.push(data[i].user_id)
					} else if (!e.target.checked && this.gift.customers.includes(data[i].user_id)) {
						this.gift.customers.splice(this.gift.customers.indexOf(data[i].user_id))
					}
				}
			},
			formatDate(date) {
				return moment.tz(date, moment.tz.guess(true)).format("MM/DD/YYYY")
			},
			sortEligible(col) {
				if (this.sortCol === col) {
					this.sortDir = this.sortDir === -1 ? 1 : -1
				} else {
					this.sortCol = col
					this.sortDir = -1
				}
			}
		},
		computed: {
			paginatedData() {
				const start = this.pageNumber * this.pageSize,
					end = start + this.pageSize

				return this.sortedEligible.slice(start, end)
			},
			sortedEligible() {
				let sorted = this.eligible
				if (this.filterRPC !== "" && parseFloat(this.filterRPC) >= 0) {
					sorted = sorted.filter(c => parseFloat(c.rev_per_call) >= parseFloat(this.filterRPC) )
				}
				if (this.filterALC !== "" && parseFloat(this.filterALC) >= 0) {
					sorted = sorted.filter(c => parseFloat(c.alc) >= parseFloat(this.filterALC) )
				}
				if (this.filterUFM !== "" && parseInt(this.filterUFM) >= 0) {
					sorted = sorted.filter(c => parseInt(c.redeemable_minutes) === parseInt(this.filterUFM))
				}
				return sorted.sort((a, b) => {
					if (a[this.sortCol] < b[this.sortCol]) return -1 * this.sortDir
					if (a[this.sortCol] > b[this.sortCol]) return 1 * this.sortDir
					return 0
				})
			},
			sortedCustomerDetail() {
				let sorted = this.customerDetail
				return sorted.sort((a, b) => {
					if (a[this.customerDetailSortCol] < b[this.customerDetailSortCol]) return -1 * this.customerDetailSortDir
					if (a[this.customerDetailSortCol] > b[this.customerDetailSortCol]) return 1 * this.customerDetailSortDir
					return 0
				})
			}
		},
		async created() {
			this.psychic = await this.$root.$data.getters.getPsychic(this.$root.$data.state, this.$route.params["id"])
			this.eligible = await this.$root.$data.getters.getEligibleGifts(this.$root.$data.state, this.$route.params["id"])
			this.idle = true
		}
	}
</script>